import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import RoleBasedAccess from '../components/RoleBasedAccess';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import Dashboard from '../pages/Dashboard';
import FileOpeningsList from '../pages/FileOpeningsList';
import FileOpeningRegister from '../pages/FileOpeningRegister';
import FileOpeningView from '../pages/FileOpeningView';
import FileOpeningCreate from '../pages/FileOpeningCreate';
import InvoicesList from '../pages/InvoicesList';
import InvoiceCreate from '../pages/InvoiceCreate';
import InvoiceView from '../pages/InvoiceView';
import ReceiptCreate from '../pages/ReceiptCreate';
import ReceiptList from '../pages/ReceiptList';
import ReceiptView from '../pages/ReceiptView.js';
import LedgerList from '../pages/Ledger.js';
import FileOpeningLedger from '../pages/FileOpeningLedger.js';
import CashRegister from '../pages/CashRegister.js';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-openings"
          element={
            <ProtectedRoute>
              <FileOpeningsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening-register"
          element={
            <ProtectedRoute>
              <RoleBasedAccess requiredRole={["admin", "superadmin"]} fallback={<Navigate to="/dashboard" />}>
                <FileOpeningRegister />
              </RoleBasedAccess>
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/create"
          element={
            <ProtectedRoute>
              <FileOpeningCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id"
          element={
            <ProtectedRoute>
              <FileOpeningView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/edit"
          element={
            <ProtectedRoute>
              <FileOpeningCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/invoices"
          element={
            <ProtectedRoute>
              <InvoicesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/invoice/create"
          element={
            <ProtectedRoute>
              <InvoiceCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/invoice/:invoiceId"
          element={
            <ProtectedRoute>
              <InvoiceView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/invoice/:invoiceId/edit"
          element={
            <ProtectedRoute>
              <InvoiceCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/receipts"
          element={
            <ProtectedRoute>
              <ReceiptList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/receipt/create"
          element={
            <ProtectedRoute>
              <ReceiptCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/receipt/:receiptId"
          element={
            <ProtectedRoute>
              <ReceiptView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/receipt/:receiptId/edit"
          element={
            <ProtectedRoute>
              <ReceiptCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-opening/:id/ledger"
          element={
            <ProtectedRoute>
              <FileOpeningLedger />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ledger"
          element={
            <ProtectedRoute>
              <RoleBasedAccess requiredRole={["admin", "superadmin"]} fallback={<Navigate to="/dashboard" />}>
                <LedgerList />
              </RoleBasedAccess>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cash-register"
          element={
            <ProtectedRoute>
              <RoleBasedAccess requiredRole={["admin", "superadmin"]} fallback={<Navigate to="/dashboard" />}>
                <CashRegister />
              </RoleBasedAccess>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </Router>
  );
};

export default AppRouter;
